let nextId = 0;
export function getId() {
    return nextId++;
}
